import type { PromptResolve } from '@ur-solutions/react-components'
import { useForm, useTranslate } from '@ur-solutions/react-hooks'
import { Checkbox, PromptModal } from '@/components'
import { Input } from '@/components_deprecated'
import type {
  AddVehicleForm,
  AddVehicleModalResolve,
} from '@/modules/vehicles/types'

interface AddVehicleModalProps {
  onSubmit: PromptResolve<AddVehicleModalResolve | null>
}

export const AddVehicleModal: React.FC<AddVehicleModalProps> = ({
  onSubmit,
}) => {
  const translations = useTranslate({
    title: 'vehicles.add-vehicle',
    submit: 'common.submit',
    regNr: 'common.reg-nr',
    name: 'common.name',
    dummyVehicle: 'vehicles.dummy-vehicle',
    dummyVehicleDescription: 'vehicles.dummy-vehicle-description',
  })
  const {
    formValues: form,
    formChangeHandler: handler,
    submitHandler: submit,
    updateForm,
  } = useForm<AddVehicleForm>({
    values: {
      isDummy: false,
      registrationNumber: '',
      name: '',
    },
  })

  const formValid = form.isDummy
    ? form.name.trim() !== ''
    : form.registrationNumber.trim() !== ''

  return (
    <PromptModal
      title={translations.title}
      className="w-[480px]"
      cancelOnClickOutside
      submitDisabled={!formValid}
      submitText={translations.submit}
      onCancel={() => onSubmit(null)}
      onSubmit={submit(form => onSubmit({ form }))}
    >
      <div className="flex flex-col gap-4">
        {form.isDummy ? (
          <div key="name" className="flex flex-col">
            <label className="mb-1.5 ml-1.5 text-sm font-semibold text-tertiary">
              {translations.name}
            </label>
            <Input
              value={form.name}
              autoFocus
              fullWidth
              onChange={handler('name')}
            />
          </div>
        ) : (
          <div key="reg-nr" className="flex flex-col">
            <label className="mb-1.5 ml-1.5 text-sm font-semibold text-tertiary">
              {translations.regNr}
            </label>
            <Input
              value={form.registrationNumber}
              autoFocus
              fullWidth
              onChange={handler('registrationNumber')}
            />
          </div>
        )}

        <div className="flex flex-col gap-2">
          <label
            htmlFor="add-vehicle-is-dummy"
            className="flex cursor-pointer items-center gap-2 text-sm font-semibold text-tertiary"
          >
            <Checkbox
              id="add-vehicle-is-dummy"
              size="sm"
              value={form.isDummy}
              onChange={checked => updateForm({ isDummy: checked === true })}
            />
            <span>{translations.dummyVehicle}</span>
          </label>

          {form.isDummy && (
            <p className="m-0 text-sm text-tertiary">
              {translations.dummyVehicleDescription}
            </p>
          )}
        </div>
      </div>
    </PromptModal>
  )
}
